import * as actionTypes from './actionTypes';
import axios from 'axios';
import fareRulesResponse from '../../assets/json/fareRules.json';

let prod = false;

export const setFareRules = (fareRules, flightId) => {
    console.log(fareRules);
    const parsedFareRules = fareRules;
    return {
        type: actionTypes.SET_FARE_RULES,
        fareRules: parsedFareRules,
        id: flightId
    }
}

export const setIntFareRules = (fareRules, flightId) => {
    const parsedFareRules = fareRules;
    return {
        type: actionTypes.SET_INT_FARE_RULES,
        fareRules: parsedFareRules,
        id: flightId
    }
}

export const setFareRulesLoading = () => {
    return {
        type: actionTypes.SET_FARE_RULES_LOADING
    }
}

export const getFareRulesFailed = () => {
    return {
        type: actionTypes.GET_FARE_RULES_FAILED
    }
}

export const getFareRules = (fareRulesParams, flightId) => {
    return dispatch => {
        dispatch(setFareRules(fareRulesResponse, flightId));
        dispatch(setFareRulesLoading());
        // let url = 'http://localhost:3000/fareRules/getFareRules';
        // if (prod) {
        //     url = 'https://secure.yatra.com/quicksilvercontroller/fareRules/getFareRules';    
        // }
        // axios
        // .get(url, { headers: {'ssoToken': localStorage.getItem('ssoToken')}, params: fareRulesParams, })
        // .then(response => {
        //     dispatch(setFareRules(response.data, flightId));
        // })
        // .catch(error => {
        //     dispatch(getFareRulesFailed());
        // });
    }
}

export const getIntFareRules = (fareRulesParams, flightId) => {
    return dispatch => {
        dispatch(setFareRulesLoading());
        let url = 'http://localhost:3000/fareRules/getIntFareRules';
        if (prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/fareRules/getIntFareRules';
        }
        axios.get(url, { headers: {'ssoToken': localStorage.getItem('ssoToken')}, params: fareRulesParams })
        .then(response => {
            dispatch(setIntFareRules(response.data, flightId));
        }) 
        .catch(error => {
            dispatch(getFareRulesFailed());
        })
    }
}

export const setSelectedFareRule = (flightId) => {
    return {
        type: actionTypes.SET_SELECTED_FARE_RULE,
        flightId: flightId
    }
}

export const setBaggageInfo = (baggageData, flightId) => {
    return {
        type: actionTypes.SET_BAGGAGE_INFO,
        baggageData: baggageData,
        id: flightId
    }
}

export const getBaggageInfo = (baggageParams, flightId) => {
    console.log(flightId);
    return dispatch => {
        let url = 'http://localhost:3000/fareRules/getBaggageInfo';
        if (prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/fareRules/getBaggageInfo';
        }
        axios.get(url, { headers: {'ssoToken': localStorage.getItem('ssoToken')}, params: baggageParams })
        .then(response => {
            console.log(response);
            dispatch(setBaggageInfo(response.data, flightId))
        })
        .catch(err => {
            console.log(err);
            // dispatch(getBaggageInfoFailed())
        })
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/fareRules.js